import DataIntegrityViolationException from './dataIntegrityViolationException'
import RemoteAuthenticationException from './remoteAuthenticationException'

export default {
    'org.springframework.dao.DataIntegrityViolationException': new DataIntegrityViolationException(),
    'org.springframework.security.authentication.rcp.RemoteAuthenticationException': new RemoteAuthenticationException()
}
